import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type {
  OtaId,
  Platform,
} from 'frontend-utils/utils/constants/constant-values';

export default class OtaHotelInfo extends Model {
  [Type] = 'ota-hotel-info' as const;

  @attr('number') declare hotelinfoId: number;
  @attr('string') declare otaId: OtaId;
  @attr() declare supportedScreenshotPlatforms: Platform[];
  @attr('boolean') declare supportsPosShopping: boolean;
}
